import { flexCenterAll, setIconFillColor } from '../../styles/mixins';
import spacing from '../../styles/spacing';
import styled, { css } from 'styled-components';
import colors from '../../styles/colors';
import { PillSize, PillType } from '../HBPill/HBPill.types';
import HBClickable from '../HBClickable/HBClickable';
import type { CSSDimensionValue } from '../../tokens/types';
import { vars } from '../../theme';

/* Pill sizes */
const pillSizes: Record<PillSize, any> = {
    [PillSize.Small]: {
        fontSize: '10px',
        lineHeight: '12px',
        borderRadius: '20px',
        height: '15px',
        padding: `2px 6px 1px`
    },
    [PillSize.Medium]: {
        fontSize: '14px',
        borderRadius: '20px',
        height: '30px',
        padding: `7px ${spacing[12]}`
    }
};

/* Pill themes */
const pillThemes: Record<PillType, any> = {
    [PillType.Draft]: {
        background: colors.neutral200,
        color: colors.neutral700
    },
    [PillType.Success]: {
        background: colors.green50,
        color: colors.white
    },
    [PillType.Sent]: {
        background: colors.blue20_20,
        color: colors.blue20
    },
    [PillType.Template]: {
        background: colors.neutral100,
        color: colors.neutral700,
        border: `1px solid ${colors.neutral200}`
    },
    [PillType.InProgress]: {
        background: colors.blue20,
        color: colors.white
    },
    [PillType.Warning]: {
        background: colors.orange50,
        color: colors.white
    },
    [PillType.Expired]: {
        background: colors.red50_15,
        color: colors.red60
    },
    [PillType.Default]: {
        background: colors.neutral200,
        color: colors.neutral900
    }
};

interface Props {
    theme: PillType;
    size: PillSize;
    $isLowerCase?: boolean;
    $isLoading?: boolean;
    $margin: CSSDimensionValue;
}

export const Pill = styled(HBClickable)<Props>`
    ${({ theme }) => pillThemes[theme]}
    font-family: ${vars.fonts.body};
    ${flexCenterAll};
    ${({ size }) => pillSizes[size]};
    margin: ${({ $margin }) => $margin};

    line-height: 1;
    border-radius: ${vars.radius.full};
    min-width: max-content;
    width: max-content;

    ${({ $isLowerCase, $isLoading }) => css`
        ${!$isLowerCase &&
        css`
            text-transform: uppercase;
            font-weight: 600;
        `}
        ${$isLoading &&
        css`
            padding: 0;
            span {
                height: 100%;
                width: 100%;
            }
        `}
    `}
`;

export const IconWrapper = styled.span<{ theme: PillType }>`
    ${({ theme }) => setIconFillColor(pillThemes[theme].color)}
    padding-right: 4px;
    padding-bottom: 0;
`;
